// extracted by mini-css-extract-plugin
export default {"modalOverlay":"pK-z","modalContent":"qK-z","header":"rK-z","close":"sK-z"};